module.exports = __webpack_public_path__ + "f975b1fce4130bb877bf7950b073becb.jpg";